<template>
  <div>
    <div class="display_between marginTop20 marginBottom20">
      <div class="fontBold fontsize16">
        历史推送记录：<span class="normalColor">{{subscriptionInfoView.length}}</span>
      </div>
      <div class="fontBold fontsize16">
        推送时间：
        <span class="normalColor" v-if="Frequency ==2">每周一 18:00</span>
         <span class="normalColor" v-if="Frequency ==1">每月1日或15日</span>
      </div>
    </div>
    <table class="gl_table">
      <tr>
        <th>日期</th>
        <th>邮箱</th>
        <th>标签</th>
        <th>推送状态</th>
      </tr>
      <tr v-for="(item,index) in subscriptionInfoView" :key="index">
        <td>
          {{item.createtime}}
        </td>
        <td>
          {{item.pushemail}}
        </td>
        <td>
          {{item.lablename}}
        </td>
        <td>
          <p v-if="subscriptionInfoView[index].status==1">已推送</p>
          <p v-if="subscriptionInfoView[index].status!=1">推送失败</p>
        </td>
      </tr>
    </table>
    <!-- <pagination></pagination> -->
  </div>
</template>

<script>
export default {
  name: "tagSubscribeRecord",
  data() {
    return {
      Frequency: 0,
      subscriptionInfoView: []//推送记录
    }
  },
  created() {
    //获取用户信息
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
      this.userName = JSON.parse(localStorage.getItem("ResData")).nickname;
    }
    this.GetSubscriptionInfoList()

  },
  methods: {
    //查询订阅信息
    GetSubscriptionInfoList() {
      let _this = this
      _this.dataList = []
      _this.httphelper.post('/api/SubscriptionApi/GetSubscriptionInfoList', {
        "id": 0,
        "lablename": "",
        "frequency": 0,
        "pushemail": "",
        "isFirstSubscript": 0,
        "userid": Number(this.AuthorId), //用户ID
        "username": "",
        "status": 0
      }).then(res => {
        if (res.data.code == 200) {
          if (res.data.data != null) {
            let data = res.data.data
            _this.Frequency = data.frequency
            //推送记录
            if (data.subscriptionInfoView != null) {
              _this.subscriptionInfoView = data.subscriptionInfoView
            }
          }
        }
      });
    },
  }
}
</script>

<style scoped>
</style>
